import EventBase from './EventBase'
import EventID from './EventID'

/**
 * 307 - 插入BGM鉴赏
 */

export default class EventBGMAdd extends EventBase {
  constructor() {
    super()
    this.Parameter = ['0', '']
  }
  //   // #region 事件内关键属性参数
  /**
   * 索引
   */
  get Index() {
    return this.Parameter![0]
  }

  set Index(val) {
    this.Parameter && (this.Parameter[0] = val?.toString())
  }

  /**
   * 描述信息
   */
  get Description() {
    return this.Parameter![1]
  }

  set Description(val) {
    this.Parameter![1] = val
  }
  //   // #endregion

  /**
   * 事件ID
   */
  Code = EventID.BGMAdd
  /**
   * 获得该事件在事件列表的描述信息（对于显示图片而言，是第9项）
   * @returns 事件描述信息
   */
}
